import { Moon, Sun } from "lucide-react";
import { useTheme } from "../hooks/useTheme";

export const ThemeToggle = ({ className = "" }) => {
    const { theme, toggle } = useTheme();
    const isDark = theme === "dark";
    return (
        <button
            type="button"
            onClick={toggle}
            data-testid="theme-toggle-btn"
            aria-label={isDark ? "Cambiar a modo diurno" : "Cambiar a modo nocturno"}
            className={`relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-gold/40 bg-background/60 text-gold backdrop-blur transition hover:border-gold hover:bg-gold/10 hover:scale-105 ${className}`}
        >
            <Sun className={`h-4 w-4 transition-all duration-500 ${isDark ? "-rotate-90 scale-0" : "rotate-0 scale-100"}`} />
            <Moon className={`absolute h-4 w-4 transition-all duration-500 ${isDark ? "rotate-0 scale-100" : "rotate-90 scale-0"}`} />
        </button>
    );
};

export default ThemeToggle;
